module.exports = __webpack_public_path__ + "img/sample-banner.781fbdc5.jpg";